<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>Add Telegram Account</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CInput v-model="form.telegram_id.val" :description="form.telegram_id.inv" label="Telegram ID" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.account_first_name.val" :description="form.account_first_name.inv" label="First Name" />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.account_last_name.val" :description="form.account_last_name.inv" label="Last Name" />
                                </CCol>
                                <CCol sm="3">
                                    <label>User</label>
                                        <model-select :options="users" v-model="form.current_user_id.val" placeholder="Please Select">
                                        <small class="form-text text-muted w-100">{{form.current_user_id.inv}}</small>
                                    </model-select>
                                </CCol>                                
                            </CRow>
                            <CRow>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.is_active.val"
                                        :description="form.is_active.inv"
                                        label="State"
                                        :options="[
                                            {value: 'true', label:'Active'},
                                            {value: 'false', label:'Inactive'},
                                        ]"
                                        placeholder="Please Select"
                                        @change="form.is_active.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CSelect
                                        v-model="form.current_lang.val"
                                        :description="form.current_lang.inv"
                                        label="Language"
                                        :options="[
                                            {value: 'fa', label:'fa'},
                                            {value: 'en', label:'en'},
                                        ]"
                                        placeholder="Please Select"
                                        @change="form.current_lang.val=$event.target.value"
                                    />
                                </CCol>
                                <CCol sm="3">
                                    <CInput v-model="form.telegram_other_side_id.val" :description="form.telegram_other_side_id.inv" label="Telegram Other Side ID" />
                                </CCol>
                                <CCol sm="3">
                                    <CTextarea v-model="form.regex.val" :description="form.regex.inv" label="Rejex" rows="1" />
                                </CCol>
                            </CRow>
                            <br>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary"> Submit</CButton>
                        </div>    
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
    components: { ModelSelect },
    data() {
        return {
            form: {
                telegram_id: {val: '', inv: '', v: { req: true, max: 1024 }},
                account_first_name: {val: '', inv: '', v: { req: true, min: 2, max: 1024 }},
                account_last_name: {val: '', inv: '', v: { req: true, min: 2, max: 1024 }},
                current_user_id: {val: '', inv: '', v: { req: true, max: 1024 }},
                is_active: {val: '', inv: '', v: { req: true, max: 1024 }},
                current_lang: {val: '', inv: '', v: { req: true, max: 1024 }},
                telegram_other_side_id: {val: '', inv: '', v: { req: true, max: 1024 }},
                regex: {val: '', inv: '', v: { req: true, max: 2048 }},
            },
            users: [],
            disable: false,
        }
    },
    mounted(){
        this.get_users();
    },
    methods: {
        validator() {
            for (const key in this.form) {
                this.form[key].inv = '';
            }
            this.disable = false;
            for (const key in this.form) {
                for (const k in this.form[key].v) {
                    switch (k) {
                        case 'req':
                            if (this.form[key].val == '') {
                                this.form[key].inv = 'This field is required.';
                                this.disable = true;
                            }
                            break;
                        case 'max':
                            if (this.form[key].val != '') {
                                if (this.form[key].val.length > this.form[key].v[k]) {
                                    this.form[key].inv = `Must be a maximum of ${this.form[key].v[k]} characters.`;
                                    this.disable = true;
                                }
                            }
                            break;
                        case 'min':
                            if (this.form[key].val != '') {
                                if (this.form[key].val.length < this.form[key].v[k]) {
                                    this.form[key].inv = `Must be at least ${this.form[key].v[k]} characters.`;
                                    this.disable = true;
                                }
                            }
                            break;
                    }
                }
            }
        },
        get_users(){
            this.axios.get('system/users/')
                .then(res => {
                    res.data.map(val => {
                        this.users.push({ value: val.id, text: `${val.id} - ${val.first_name} ${val.last_name}` });
                    });
                })
        },
        submit(){
            if(this.disable == false){
                const data = new FormData();
                for (const key in this.form){
                    data.set(key, this.form[key].val);
                }
                this.axios.post('system/telegram_accounts/', data)
                    .then(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            text: 'Submitted Successfully.'
                        });
                        this.$router.push('/telegram/accounts');
                    })
                    .catch(() => {
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            text: 'Error! please try again.'
                        });
                    })
            }
        }
    }
}
</script>
